import React, { useEffect, useRef, useState } from 'react';
import { buildHeroScene, supportsWebGL } from '../../utils/heroScene';
interface HeroSculptureProps {
  fallbackSrc: string;
}
type RenderMode = 'loading' | 'webgl' | 'fallback';
export function HeroSculpture({
  fallbackSrc
}: HeroSculptureProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [mode, setMode] = useState<RenderMode>('loading');
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (!supportsWebGL()) {
      setMode('fallback');
      return;
    }
    let cancelled = false;
    let cleanup: (() => void) | null = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Promise.all([import('three'), import('three/examples/jsm/environments/RoomEnvironment.js')]).then(([THREE, environment]) => {
      if (cancelled) return;
      try {
        cleanup = buildHeroScene(THREE, environment.RoomEnvironment, container, reduceMotion);
        setMode('webgl');
      } catch {
        setMode('fallback');
      }
    }).catch(() => {
      if (!cancelled) setMode('fallback');
    });
    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);
  return <div className="relative h-full w-full" aria-hidden="true" data-id="element-459" data-mp="1b21z482buwze">
      {mode === 'fallback' && <img src={fallbackSrc} alt="" className="h-full w-full object-contain" data-id="element-460" data-mp="1f3dm05tth43w" />}
      <div ref={containerRef} className={`absolute inset-0 transition-opacity duration-300 ease-out ${mode === 'webgl' ? 'opacity-100' : 'opacity-0'}`} data-id="element-461" data-mp="118l2kwat33s1" />
    </div>;
}